export function FlexibleCenteredDiv({children,className}){
    return <div className={`flex items-center justify-center flex-1 ${className}`}>{children}</div>
}